// src/config.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyABOrQafjEubSbNXsrqDlEB_Sg5ctzjL4g",
  authDomain: "torim-adda4.firebaseapp.com",
  projectId: "torim-adda4",
  storageBucket: "torim-adda4.firebasestorage.app",
  messagingSenderId: "977710960880",
  appId: "1:977710960880:web:019122353506acf3c77235",
  measurementId: "G-S9L2BWJ4FK"
};

const app = initializeApp(firebaseConfig);

// זה מה שנשתמש בו בשאר הקוד:
export const db = getFirestore(app);
